// Init slider
export function InitServicesPage(container: HTMLElement) {
    let currentSlide = 0;

    let togglesContainer = container.querySelector(".services-toggle");
    let slidesContainer = container.querySelector(".service-slides");

    let slides = Array.from(slidesContainer.querySelectorAll(".slide"));
    let toggles = Array.from(togglesContainer.querySelectorAll(".item"));

    toggles.forEach((item, index) => {
        item.addEventListener("click", () => {
            toggles[currentSlide].classList.remove("active");
            toggles[index].classList.add("active");
            slides[currentSlide].classList.remove("active");
            slides[index].classList.add("active");
            currentSlide = index;
        })
    })

    // Mobile version
    {
        let togglesContainer = container.querySelector(".services-toggle-mobile");
        let currentItem = container.querySelector(".current-item");
        let currentItemName = container.querySelector(".current-item > .name");

        let toggles = Array.from(togglesContainer.querySelectorAll(".items div"));
    
        currentItem.addEventListener("click", ()=> {
            let isActive = togglesContainer.classList.contains("active");
            if (isActive) {
                togglesContainer.classList.remove("active");
            } else {
                togglesContainer.classList.add("active");
            }
        })

        toggles.forEach((item, index) => {
            item.addEventListener("click", () => {
                // Change current toggle
                toggles.forEach((item, index) => {
                    item.classList.remove("active")
                });
                item.classList.add("active");

                slides[currentSlide].classList.remove("active");
                slides[index].classList.add("active");
                currentSlide = index;
                
                togglesContainer.classList.remove("active");
                currentItemName.innerHTML = item.innerHTML;
               
            })
        })
    }
}
